const createButtonTokens = ({ colors, borders, space }) => ({
  colors: {
    primary: {
      bgColor: colors.primary['50'],
      color: colors.neutral['0'],
      hover: {
        bgColor: colors.primary['30'],
        color: colors.neutral['0'],
      },
      active: {
        bgColor: colors.primary['30'],
        color: colors.neutral['0'],
      },
      disabled: {
        bgColor: colors.neutral['30'],
        color: colors.neutral['50'],
      },
      inverted: {
        bgColor: colors.neutral['0'],
        color: colors.primary['50'],
        hover: {
          bgColor: colors.primary['20'],
          color: colors.primary['70'],
        },
        active: {
          bgColor: colors.primary['20'],
          color: colors.primary['70'],
        },
        disabled: {
          bgColor: colors.neutral['30'],
          color: colors.neutral['60'],
        },
      },
    },
    secondary: {
      color: colors.primary['50'],
      bgColor: colors.neutral['0'],
      hover: {
        bgColor: colors.primary['20'],
        color: colors.primary['50'],
      },
      active: {
        bgColor: colors.primary['20'],
        color: colors.primary['50'],
      },
      disabled: {
        bgColor: colors.neutral['30'],
        color: colors.neutral['50'],
      },
      inverted: {
        color: colors.neutral['0'],
        disabled: {
          color: colors.neutral['30'],
        },
      },
    },
    text: {
      color: colors.primary['50'],
      hover: {
        color: colors.primary['70'],
        bgColor: colors.primary['20'],
      },
      active: {
        color: colors.primary['70'],
        bgColor: colors.primary['20'],
      },
      disabled: {
        color: colors.neutral['50'],
      },
      inverted: {
        color: colors.neutral['0'],
        hover: {
          color: colors.neutral['0'],
          bgColor: colors.neutral['0'],
        },
        disabled: {
          color: colors.neutral['30'],
        },
      },
    },
    /**
     * @deprecated
     * use primary instead
     */
    highlight: {
      bgColor: colors.primary['50'],
      hover: {
        borderColor: colors.primary['20'],
        bgColor: colors.primary['30'],
      },
      active: {
        bgColor: colors.primary['30'],
        color: colors.primary['20'],
      },
      disabled: {
        bgColor: colors.neutral['30'],
        color: colors.neutral['50'],
      },
    },
    /**
     * @deprecated
     * no default button in cobalt design system
     * */
    default: {
      color: colors.primary['50'],
      borderColor: colors.primary['50'],
      hover: {
        color: colors.primary['50'],
        borderColor: colors.primary['50'],
        bgColor: colors.primary['20'],
      },
      active: {
        color: colors.primary['50'],
        borderColor: colors.primary['50'],
      },
      disabled: {
        bgColor: colors.neutral['0'],
        color: colors.neutral['50'],
        borderColor: colors.neutral['50'],
      },
    },
  },
  space: {
    small: {
      px: space['base'],
      py: space['1x_small'],
    },
    medium: {
      px: space['big'],
      py: space['small'],
    },
    /**
     * @deprecated
     * use medium instead
     * */
    large: {
      px: space['big'],
      py: space['small'],
    },
  },
  borders: {
    default: borders[1],
  },
  radii: [0, 42],
  opacity: 1,
  lineHeights: ['18px', '20px'],
});

export default createButtonTokens;
